export const toggleScroll = {
    $body: $("body"),
    topPosition: 0,
    lockScroll: function (aditionalClass) {
        this.topPosition = $(window).scrollTop();
        this.$body.addClass(aditionalClass);
        setTimeout(() => {
            this.$body.css({
                "position": "fixed",
                "top": -this.topPosition + "px",
                "width": "100%",
                "height": "auto",
            });
        }, 750);
    },
    unLockScroll: function (aditionalClass) {
        this.$body.removeClass(aditionalClass);
        this.$body.css({
            "position": "",
            "top": "",
            "width": "",
            "height": "",
        });
        $(window).scrollTop(this.topPosition);
    },
};



// WEBPACK FOOTER //
// ./assets/js/modules/toggleScroll.js